import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=fece265c&scoped=true&"
var script = {}
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=fece265c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fece265c",
  null
  
)

export default component.exports